module.exports = __webpack_public_path__ + "img/resource-tech-image-28.d53d88f3.png";